import translations from "@/i18n";
import _ from "lodash";

_.templateSettings.interpolate = /{{([\s\S]+?)}}/g;

export default {
  t(key: string, locale = "en", context = {}) {
    // @ts-ignore
    return _.template(_.get(translations[locale], key), {
      interpolate: /{{([\s\S]+?)}}/g,
    })(context);
  },
  locale: "en" as "jp" | "en",
};
